import {
  Input as MuiInput,
  InputAdornment as MuiInputAdornment,
  type InputAdornmentProps,
  Typography,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const Label = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$line",
})<{ $line?: boolean }>(({ theme, $line }) => ({
  ...($line
    ? { letterSpacing: "0.4px" }
    : {
        [theme.breakpoints.down(900)]: {
          display: "none",
        },
      }),
}));

export const Input = styled(MuiInput, {
  shouldForwardProp: (prop) => prop !== "$line",
})<{ $line?: boolean }>(({ theme, $line }) => ({
  ...($line && {
    padding: theme.spacing(0.25, 1.25),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: `${theme.shape.borderRadius}px`,
    transition: theme.transitions.create("border-color", {
      duration: theme.transitions.duration.shorter,
    }),

    "&:hover": {
      borderColor: theme.palette.text.secondary,
    },

    "&.Mui-focused": {
      borderColor: theme.palette.secondary.main,
    },

    "&::before, &::after": {
      display: "none",
    },
  }),

  [theme.breakpoints.down(600)]: {
    fontSize: "11px",
  },
}));

export const PresetButton = styled("button", {
  shouldForwardProp: (prop) => prop !== "$active" && prop !== "$line",
})<{ $active: boolean; $line?: boolean }>(({ theme, $active, $line }) => ({
  width: "100%",
  padding: "4px 8px",
  fontFamily: "inherit",
  fontSize: 11,
  fontWeight: $active ? 700 : 500,
  color: theme.palette.text.primary,
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer",

  ...($line && {
    padding: theme.spacing(0.5, 1),
    color: $active ? theme.palette.text.primary : theme.palette.text.secondary,
    backgroundColor: $active
      ? alpha(theme.palette.secondary.main, 0.12)
      : "transparent",
    border: `1px solid ${$active ? theme.palette.secondary.main : theme.palette.divider}`,
    borderRadius: 999,
    transition: theme.transitions.create(
      ["background-color", "border-color", "color"],
      { duration: theme.transitions.duration.shorter }
    ),

    "&:hover": {
      borderColor: theme.palette.secondary.main,
    },
  }),
}));

export const InputAdornment = styled(MuiInputAdornment)<InputAdornmentProps>(
  ({ theme }) => ({
    p: {
      [theme.breakpoints.down(600)]: {
        fontSize: "11px",
      },
    },
  })
);
